import { useContext, useEffect, useState, useRef } from "react";
import { isTemporal, propertiesTypeInTemporal } from "../../../Utils/Functions";
import { useFilters } from "../Filters.hook";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { propertyTypes } from "shared-components/ViewFragments/SearchResults/Sider/TopBarFilters/options";

const usePropertyType = props => {
  const { filters, changeFilters, filtersTags } = useFilters();
  const { country_code } = useContext(ConfigStateContext);
  const {
    labeled = false,
    inputType = "select",
    filterChanged = changeFilters,
  } = props;
  const [options, setOptions] = useState([]);
  const [activeValue, setActiveValue] = useState([]);
  const data = propertyTypes.filter(type => type.countries.includes(country_code ? country_code.toUpperCase() : ""));
  const prevValueRef = useRef([]);
  const allValue = -1;

  const onChange = newValue => {
    if (!newValue) return null;

    const newPropertiesTypeValues = newValue.map((type) => type.value);
    const showSurfaceRange = [3, 12].some(e => newPropertiesTypeValues.includes(e))
    let filterValues = {
      property_type_id: newValue,
      m2Min: showSurfaceRange ? filtersTags?.m2Min : null,
      m2Max: showSurfaceRange ? filtersTags?.m2Max : null,
      m2Type: showSurfaceRange ? filtersTags?.m2Type : null
    }

    const prevValue = prevValueRef.current;
    const hasZero = newValue.some(item => item.value === allValue);
    const hadZero = prevValue.some(item => item === allValue) || !prevValue.length;
    const isAllOnlySelected = newValue.length === 1 && newValue.some(item => item.value === allValue);

    if (hasZero && !hadZero || isAllOnlySelected) {
      filterValues = { ...filterValues, property_type_id: [] }
      setActiveValue([allValue])
      prevValueRef.current = [allValue]
    } else if (hasZero && hadZero && newValue.length > 1) {
      let res = newValue.map(item => {
        if (item.value === allValue) return;
        return item;
      }).filter(item => item)
      const onlyValues = res.map(item => item.value)

      filterValues = { ...filterValues, property_type_id: res }
      setActiveValue(onlyValues)
      prevValueRef.current = onlyValues
    } else {
      const onlyValues = newValue.map(item => item.value)
      
      filterValues = { ...filterValues, property_type_id: newValue }
      setActiveValue(onlyValues)
      prevValueRef.current = onlyValues
    }

    filterChanged(filterValues);
  };

  const type = "multiple";

  useEffect(() => {
    const currentValue = Array.isArray(filters?.property_type_id) && !!filters?.property_type_id.length
      ? filters.property_type_id.map(item => item.value || item)
      : [allValue];
    
    // Solo actualizar si hay un cambio real
    if (JSON.stringify(currentValue) !== JSON.stringify(activeValue)) {
      setActiveValue(currentValue);
      prevValueRef.current = currentValue;
    }
  }, [filters?.property_type_id, options]);

  useEffect(() => {
    if (data && filters.operation_type_id && country_code) {
      const list = (isTemporal(filters.operation_type_id) && country_code !== "CO")
        ? data?.filter(e => propertiesTypeInTemporal(Number(e.value)))
        : data;
      const filteredByProjects = filters.projects ? list.filter(item => item.projects === !!filters.projects) : list
      const finalList = filteredByProjects.map((type) => ({ text: type.text, value: type.value }))
      
      setOptions(finalList)
    }
  }, [filters.operation_type_id, filters.projects, country_code]);

  return {
    data: {
      options,
      onChange,
      value: activeValue,
      type: type,
      customKey: "property_type_id",
    },
    show: true,
    labeled,
    label: "",
    inputType,
  };
};

export { usePropertyType };